// =============================================================================
// AGENT 4 — STRATEG KONWERSJI: MIKROKOPY
// Wszystkie teksty UI w jednym pliku. Zero hardkodowanych stringów w JSX.
// =============================================================================

export const COPY = {
  start: {
    eyebrow: 'Conference demo table · mobile-first dispatch challenge',
    logoAlt: 'ResiCraft',
    headline: 'Zostań brygadzistą na 90 sekund.',
    subheadline: 'Dopasuj zgłoszenia do właściwych ludzi szybciej niż robi to chaos operacyjny.',
    stats: ['90 sekund', '4 zgłoszenia', '4 pracowników'],
    ctaButton: 'Start — zacznij grę',
    rulesTitle: 'Jak grać?',
    rules: [
      'Przeciągaj kafelki zgłoszeń do odpowiednich pracowników',
      'Masz 90 sekund — priorytetyzuj awarie',
      'Wynik porówna Twoje decyzje z rekomendacją AI',
    ],
  },
  game: {
    tasksColumnTitle: 'Zgłoszenia',
    workersColumnTitle: 'Pracownicy',
    finishButton: 'Gotowe — pokaż wynik',
    dropHint: 'Przeciągnij zgłoszenie',
    dropHintActive: 'Upuść tutaj',
    assignmentAckSuccess: 'Przypisanie zapisane',
    assignmentAckError: 'Nie udało się przypisać zgłoszenia',
    finalAlert: 'Finał rundy: priorytety i tempo!',
  },
  results: {
    headline: (pct: number) =>
      pct >= 90 ? 'Imponujące! Myślisz jak system AI.' :
      pct >= 60 ? `Dobry wynik — ${pct}% zgodności z ResiCraft` :
      `Twój wynik: ${pct}% zgodności z ResiCraft`,
    aiTimeLabel: 'Czas decyzji AI:',
    playerTimeLabel: 'Twój czas:',
    comparisonTagline: (playerTimeSeconds: number) =>
      `Ty potrzebowałeś ${playerTimeSeconds} sekund. System ResiCraft robi to w mniej niż sekundę.`,
    verdictLevelOne: 'Decyzja poprawna',
    verdictLevelTwo: 'Poprawne dopasowanie z karą',
    verdictLevelThree: 'Niepoprawne dopasowanie',
    leadCta: 'Chcesz dowiedzieć się więcej o ResiCraft? Zostaw namiar.',
    leadButton: 'Zostaw kontakt',
    leadSent: 'Dzięki! Odezwiemy się wkrótce.',
    restartButton: 'Zagraj ponownie',
  },
  lead: {
    namePlaceholder: 'Imię i nazwisko',
    emailPlaceholder: 'Służbowy adres e-mail',
    companyPlaceholder: 'Firma / organizacja',
    submitButton: 'Wyślij',
    privacyNote: 'Dane zostaną użyte wyłącznie do kontaktu w sprawie ResiCraft.',
    validationEmail: 'Podaj poprawny adres e-mail.',
    validationRequired: 'To pole jest wymagane.',
    missingConfig: 'Brak konfiguracji formularza. Ustaw zmienne środowiskowe EmailJS.',
    errorGeneral: 'Coś poszło nie tak. Spróbuj ponownie.',
    errorTimeout: 'Przekroczono limit czasu połączenia. Spróbuj ponownie.',
    retryButton: 'Spróbuj ponownie',
  },
  leaderboard: {
    leaderboardTitle: 'Ranking TOP 6',
    leaderboardHeaderScore: 'Zgodność',
    leaderboardHeaderTime: 'Czas',
    leaderboardHeaderPlayer: 'Gracz',
    leaderboardPlayerHighlight: 'Twój wynik',
    leaderboardNicknameLabel: 'nick gracza',
    leaderboardSaveButton: 'Zapisz wynik',
    leaderboardConfirmButton: 'Zatwierdź nick',
    leaderboardEmptyState: 'Ranking jest obecnie niedostępny. Graj dalej!',
    leaderboardError: 'Wystąpił błąd podczas komunikacji z serwerem. Twój wynik został zapisany lokalnie.',
  },
} as const;
